export default {
    /**
     * default time to be put on the debounce function when dealing with user input that needs to
     * apply a filter
     */
    INPUT_APPLY_DEBOUNCE_TIME: 500,
};